var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3056"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F6F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M40 34.8V39.7029C40 40.0212 40.1264 40.3264 40.3515 40.5515L43 43.2M25 31.2V30C25 26.6863 27.6863 24 31 24H32.2M47.8 24L49 24C52.3137 24 55 26.6863 55 30V31.2M30.4 49.8L26.2 54M53.8 54L49.6 49.8M53.2 40.2C53.2 47.4902 47.2902 53.4 40 53.4C32.7098 53.4 26.8 47.4902 26.8 40.2C26.8 32.9098 32.7098 27 40 27C47.2902 27 53.2 32.9098 53.2 40.2Z",
    stroke: "#825DFC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e1c346f72fad4f1e34671a77706dbc2b.svg";
export { ForwardRef as ReactComponent };